import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';

const PnLCalendar = () => {
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    const [pnlData, setPnlData] = useState({});
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const currentYear = 2025;

    // Your CSV data as a string (replace this with file loading logic if needed)
    const csvData = `date,daily_pnl,cumulative_pnl
2024-10-09,0.0,10000.0
2024-10-10,-47.61000000000058,9952.39
2024-10-11,0.0,9952.39
2024-10-12,2327.3899999999994,12279.779999999999
2024-10-13,-123.75,12156.029999999999
2024-10-14,-340.31000000000495,11815.719999999994
2024-10-15,-3.4799999999959255,11812.239999999998
2024-10-16,-649.0899999999965,11163.150000000001
2024-10-17,-104.19999999999709,11058.950000000004
2024-10-18,-470.3600000000006,10588.590000000004
2024-10-19,-156.05999999999767,10432.530000000006
2024-10-20,-143.47000000000116,10289.060000000005
2024-10-21,79.81999999999243,10368.879999999997
2024-10-22,-284.6000000000058,10084.279999999992
2024-10-23,-236.5,9847.779999999992
2024-10-24,38.5,9886.279999999992
2024-10-25,-187.47999999999593,9698.799999999996
2024-10-26,214.92999999999302,9913.729999999989
2024-10-27,-5.6600000000034925,9908.069999999985
2024-10-28,-208.42999999999302,9699.639999999992
2024-10-29,458.7100000000064,10158.349999999999
2024-10-30,-286.99000000000524,9871.359999999993
2024-10-31,-284.8799999999901,9586.480000000003
2024-11-01,-302.0500000000029,9284.43
2024-11-02,-215.4100000000035,9069.019999999997
2024-11-03,493.4400000000023,9562.46
2024-11-04,-73.22999999999593,9489.230000000003
2024-11-05,676.4499999999971,10165.68
2024-11-06,2133.550000000003,12299.230000000003
2024-11-07,275.1900000000023,12574.420000000006
2024-11-08,-78.98999999999069,12495.430000000015
2024-11-09,-245.22000000000116,12250.210000000014
2024-11-10,2259.649999999994,14509.860000000008
2024-11-11,-848.2000000000116,13661.659999999996
2024-11-12,-679.3399999999965,12982.32
2024-11-13,244.75,13227.07
2024-11-14,-842.9800000000105,12384.08999999999
2024-11-15,-478.1600000000035,11905.929999999986
2024-11-16,-443.34000000001106,11462.589999999975
2024-11-17,-293.06999999999243,11169.519999999982
2024-11-18,421.84999999999127,11591.369999999974
2024-11-19,-64.50999999999476,11526.859999999979
2024-11-20,-364.0200000000041,11162.839999999975
2024-11-21,-449.33000000000175,10713.509999999973
2024-11-22,191.9600000000064,10905.46999999998
2024-11-23,-412.47000000000116,10492.999999999978
2024-11-24,-512.8300000000017,9980.169999999976
2024-11-25,237.50999999999476,10217.679999999971
2024-11-26,-717.7000000000116,9499.97999999996
2024-11-27,424.75999999999476,9924.739999999954
2024-11-28,450.0899999999965,10374.82999999995
2024-11-29,444.6499999999942,10819.479999999945
2024-11-30,-319.91999999999825,10499.559999999947
2024-12-01,-512.5099999999948,9987.049999999952
2024-12-02,2096.0399999999936,12083.089999999946
2024-12-03,-51.66000000000349,12031.429999999942
2024-12-04,-469.0,11562.429999999942
2024-12-05,3723.9600000000064,15286.389999999948
2024-12-06,0.0,15286.389999999948
2024-12-07,1136.7899999999936,16423.179999999942
2024-12-08,-479.18000000000757,15943.999999999935
2024-12-09,-207.65000000000873,15736.349999999926
2024-12-10,345.3099999999977,16081.659999999923
2024-12-11,633.8300000000017,16715.489999999925
2024-12-12,-338.74000000000524,16376.74999999992
2024-12-13,-258.08000000000175,16118.669999999918
2024-12-14,0.0,16118.669999999918
2024-12-15,-482.2899999999936,15636.379999999925
2024-12-16,-595.6699999999983,15040.709999999926
2024-12-17,-88.60000000000582,14952.10999999992
2024-12-18,749.7099999999919,15701.819999999912
2024-12-19,-1322.340000000011,14379.479999999901
2024-12-20,-721.570000000007,13657.909999999894
2024-12-21,620.7400000000052,14278.6499999999
2024-12-22,258.7199999999866,14537.369999999886
2024-12-23,-1392.0099999999948,13145.359999999891
2024-12-24,-240.5399999999936,12904.819999999898
2024-12-25,-424.75999999999476,12480.059999999903
2024-12-26,2703.9900000000052,15184.049999999908
2024-12-27,-292.09999999999127,14891.949999999917
2024-12-28,-160.4100000000035,14731.539999999914
2024-12-29,-166.83000000000175,14564.709999999912
2024-12-30,-566.7599999999948,13997.949999999917
2024-12-31,2348.449999999997,16346.399999999914
2025-01-01,-11.169999999998254,16335.229999999916
2025-01-02,943.3500000000058,17278.57999999992
2025-01-03,-226.4499999999971,17052.129999999925
2025-01-04,-75.97999999999593,16976.14999999993
2025-01-05,-78.45000000001164,16897.699999999917
2025-01-06,545.25,17442.949999999917
2025-01-07,-266.91999999999825,17176.02999999992
2025-01-08,971.3099999999977,18147.339999999916
2025-01-09,1582.6199999999953,19729.95999999991
2025-01-10,1591.1900000000023,21321.149999999914
2025-01-11,-103.30999999999767,21217.839999999916
2025-01-12,-195.93000000000757,21021.90999999991
2025-01-13,-332.4499999999971,20689.45999999991
2025-01-14,-286.20999999999185,20403.24999999992
2025-01-15,-798.4400000000023,19604.809999999918
2025-01-16,77.1299999999901,19681.939999999908
2025-01-17,0.0,19681.939999999908
2025-01-18,2236.279999999999,21918.219999999907
2025-01-19,-159.50999999999476,21758.70999999991
2025-01-20,6648.229999999996,28406.939999999908
2025-01-21,-416.0199999999895,27990.91999999992
2025-01-22,-396.52999999999884,27594.38999999992
2025-01-23,460.5500000000029,28054.939999999922
2025-01-24,-850.6900000000023,27204.24999999992
2025-01-25,-399.40000000000873,26804.84999999991
2025-01-26,206.97999999999593,27011.829999999907
2025-01-27,1714.6499999999942,28726.4799999999
2025-01-28,755.320000000007,29481.79999999991
2025-01-29,427.52999999999884,29909.329999999907
2025-01-30,247.38000000000466,30156.70999999991
2025-01-31,-140.35000000000582,30016.359999999906
2025-02-01,-368.74000000000524,29647.6199999999
2025-02-02,0.0,29647.6199999999
2025-02-03,6612.149999999994,36259.769999999895
2025-02-04,2041.1399999999994,38300.909999999894
2025-02-05,-345.070000000007,37955.83999999989
2025-02-06,1089.1600000000035,39044.99999999989
2025-02-07,-767.7799999999988,38277.21999999989
2025-02-08,-434.4600000000064,37842.759999999886
2025-02-09,-119.22999999999593,37723.52999999989
2025-02-10,555.7099999999919,38279.23999999988
2025-02-11,-354.8999999999942,37924.33999999989
2025-02-12,-171.38999999999942,37752.94999999989
2025-02-13,1572.770000000004,39325.71999999989
2025-02-14,-17.80999999999767,39307.909999999894
2025-02-15,-261.20999999999185,39046.6999999999
2025-02-16,-84.02999999999884,38962.669999999904
2025-02-17,-523.0399999999936,38439.62999999991
2025-02-18,-355.7700000000041,38083.859999999906
2025-02-19,81.20999999999185,38165.0699999999
2025-02-20,75.47000000000116,38240.5399999999
2025-02-21,-277.08000000000175,37963.4599999999
2025-02-22,-353.9400000000023,37609.519999999895
2025-02-23,-9.44999999999709,37600.0699999999
2025-02-24,-56.270000000004075,37543.799999999894
2025-02-25,-493.0,37050.799999999894
2025-02-26,24.660000000003492,37075.4599999999
2025-02-27,-970.2899999999936,36105.169999999904
2025-02-28,738.1699999999983,36843.3399999999
2025-03-01,63.770000000004075,36907.109999999906
2025-03-02,-413.70999999999185,36493.399999999914
2025-03-03,-786.8400000000111,35706.5599999999
2025-03-04,-1919.0599999999977,33787.499999999905
2025-03-05,-796.0299999999988,32991.46999999991
2025-03-06,-518.5200000000041,32472.949999999903
2025-03-07,-201.88999999999942,32271.059999999903
2025-03-08,0.0,32271.059999999903
2025-03-09,-118.25,32152.809999999903
2025-03-10,47.70999999999185,32200.519999999895
2025-03-11,2168.729999999996,34369.24999999989
2025-03-12,626.5899999999965,34995.83999999989
2025-03-13,-969.1000000000058,34026.73999999988
2025-03-14,1104.0499999999884,35130.78999999987
2025-03-15,-335.0599999999977,34795.72999999987
2025-03-16,-492.99000000000524,34302.73999999987
2025-03-17,-607.0,33695.73999999987
2025-03-18,-317.7899999999936,33377.94999999987
2025-03-19,-514.6000000000058,32863.34999999987
2025-03-20,-322.4800000000105,32540.869999999857
2025-03-21,-442.49000000000524,32098.379999999852
2025-03-22,-109.08999999999651,31989.289999999855
2025-03-23,789.2000000000116,32778.48999999987
2025-03-24,1393.3199999999924,34171.80999999986
2025-03-25,-128.42999999999302,34043.37999999987
2025-03-26,83.83999999999651,34127.21999999986
2025-03-27,-134.33000000000175,33992.88999999986
2025-03-28,1647.1499999999942,35640.039999999855
2025-03-29,246.25,35886.289999999855
2025-03-30,-63.80000000000291,35822.48999999985
2025-03-31,-785.9900000000052,35036.49999999985
2025-04-01,117.77999999999884,35154.279999999846
2025-04-02,462.83000000000175,35617.10999999985
2025-04-03,0.0,35617.10999999985
2025-04-04,548.5099999999948,36165.61999999984
2025-04-05,-127.9200000000128,36037.69999999983
2025-04-06,-37.720000000001164,35999.97999999983
2025-04-07,1438.75,37438.72999999983
2025-04-08,-1095.8800000000047,36342.84999999983
2025-04-09,507.00999999999476, 36849.85999999983
2025-04-10,278.6399999999994, 37128.49999999983
2025-04-11,1648.0299999999988, 38776.52999999983
2025-04-12,-351.50999999999476, 38425.01999999983
2025-04-13,319.6499999999942, 38744.66999999983
2025-04-14,-313.9800000000105, 38430.68999999983
2025-04-15,442.0, 38872.68999999983
2025-04-16,-481.02999999999884, 38391.65999999983
2025-04-17,-225.88999999999942, 38165.76999999983
2025-04-18,57.470000000001164, 38223.23999999983
2025-04-19,374.250, 38697.48999999983
2025-04-20,600.8799999999901, 39300.36999999983
2025-04-21,-371.20999999999185, 38929.15999999983
2025-04-22,0.0, 38929.15999999983
2025-04-23,4527.229999999996, 43456.38999999983
2025-04-24,-595.2299999999959, 42861.15999999983
2025-04-25,58.320000000006985, 42919.47999999983
2025-04-26,29.089999999996508, 42948.56999999983
2025-04-27,-78.13000000000466, 42870.43999999983
2025-04-28,978.2400000000052, 43848.67999999983
2025-04-29,-186.65999999998894, 43662.01999999983
2025-04-30,-180.32000000000698, 43481.69999999983
2025-05-01,1077.729999999996, 44559.42999999983
2025-05-02,-438.77999999999884, 44120.64999999983
2025-05-03,-33.14999999999418, 44087.49999999983
2025-05-04,-350.6100000000006, 43736.88999999983
2025-05-05,-773.6699999999983, 42963.21999999983
2025-05-06,-64.52999999999884, 42900.68999999983
2025-05-07,444.63000000000466, 43345.31999999983
2025-05-08,1085.9400000000023, 44431.25999999983
2025-05-09,-285.6499999999942, 44145.60999999983
2025-05-10,494.8799999999901, 44640.48999999983
2025-05-11,-459.1600000000035, 44181.32999999983
2025-05-12,-435.06999999999243, 43746.25999999983
2025-05-13,-686.0100000000093, 43060.24999999983
2025-05-14,-133.05999999999767, 42927.18999999983
2025-05-15,584.0299999999988, 43511.21999999983
2025-05-16,-180.15000000000873, 43331.06999999983
2025-05-17,106.3799999999901, 43437.44999999983
2025-05-18,361.18000000000757, 43798.62999999983
2025-05-19,1517.550000000003, 45316.17999999983
2025-05-20,-1149.8699999999953, 44166.30999999983
2025-05-21,-701.1699999999983, 43465.13999999983
2025-05-22,600.6699999999983, 44065.80999999983
2025-05-23,162.02999999999884, 44227.83999999983
2025-05-24,-277.6100000000006, 43950.22999999983
2025-05-25,-128.29999999998836, 43821.92999999983
2025-05-26,-299.679999999993, 43522.24999999983
2025-05-27,304.4100000000035, 43826.65999999983
2025-05-28,-292.1399999999994, 43534.51999999983
2025-05-29,-559.6299999999901, 42974.88999999983`;

    // Parse CSV and set PnL data
    useEffect(() => {
        const parsedData = Papa.parse(csvData, { header: true, skipEmptyLines: true });
        const formattedPnlData = {};

        parsedData.data.forEach(row => {
            const date = new Date(row.date);
            const year = date.getFullYear();
            const month = date.getMonth(); // 0-indexed
            const day = date.getDate();

            // Only include data for the current year and month
            if (year === currentYear && month === currentMonth) {
                formattedPnlData[day] = {
                    value: parseFloat(row.daily_pnl),
                    hasData: true
                };
            }
        });

        setPnlData(formattedPnlData);
    }, [currentMonth, currentYear]); // Re-run when month or year changes

    // Calculate total PnL for the current month
    const calculateTotalPnL = () => {
        return Object.values(pnlData).reduce((total, day) => total + (day.value || 0), 0);
    };

    // Generate calendar days for the month
    const generateCalendarDays = () => {
        const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
        const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();

        const daysInPrevMonth = new Date(currentYear, currentMonth, 0).getDate();
        const prevMonthDays = [];
        for (let i = daysInPrevMonth - firstDayOfMonth + 1; i <= daysInPrevMonth; i++) {
            prevMonthDays.push({
                day: i,
                isCurrentMonth: false,
                isPrevMonth: true
            });
        }

        const currentMonthDays = [];
        for (let i = 1; i <= daysInMonth; i++) {
            currentMonthDays.push({
                day: i,
                isCurrentMonth: true,
                pnl: pnlData[i]
            });
        }

        const totalDaysDisplayed = prevMonthDays.length + currentMonthDays.length;
        const remainingCells = totalDaysDisplayed % 7 === 0 ? 0 : 7 - (totalDaysDisplayed % 7);
        const nextMonthDays = [];
        for (let i = 1; i <= remainingCells; i++) {
            nextMonthDays.push({
                day: i,
                isCurrentMonth: false,
                isNextMonth: true
            });
        }

        return [...prevMonthDays, ...currentMonthDays, ...nextMonthDays];
    };

    const formatPnL = (amount) => {
        if (!amount && amount !== 0) return '';
        const prefix = amount >= 0 ? '$' : '-$';
        const formattedAmount = Math.abs(amount).toFixed(2); // Always show 2 decimal places
        return `${prefix}${formattedAmount}`;
    };

    const getDayStyle = (day) => {
        if (!day.pnl || !day.pnl.hasData) return '';
        return day.pnl.value >= 0 ? 'positive-pnl' : 'negative-pnl';
    };

    const getDateCellClass = (day) => {
        if (!day.isCurrentMonth) return 'date-cell inactive-month';
        return 'date-cell';
    };

    const getDayNumberClass = (day) => {
        if (!day.pnl || !day.pnl.hasData) return 'day-number';
        return day.pnl.value >= 0 ? 'day-number positive-day' : 'day-number negative-day';
    };

    const changeMonth = (direction) => {
        let newMonth = currentMonth + direction;
        if (newMonth < 0) {
            newMonth = 11;
        } else if (newMonth > 11) {
            newMonth = 0;
        }
        setCurrentMonth(newMonth);
    };

    const days = generateCalendarDays();

    return (
        <div className="pnl-calendar-container">
            <div className="month-navigation-container">
                <button
                    className="month-nav-btn"
                    onClick={() => changeMonth(-1)}
                >
                    {months[(currentMonth - 1 + 12) % 12]}
                </button>
                <h2 className="calendar-title">BTC PnL for {months[currentMonth]} {currentYear}</h2>
                <button
                    className="month-nav-btn"
                    onClick={() => changeMonth(1)}
                >
                    {months[(currentMonth + 1) % 12]}
                </button>
            </div>

            <div className="total-pnl">
                Total PnL: <span className={calculateTotalPnL() >= 0 ? 'positive-amount' : 'negative-amount'}>
                    ${calculateTotalPnL().toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                </span>
            </div>

            <div className="calendar-grid">
                <div className="weekday-header">Sun</div>
                <div className="weekday-header">Mon</div>
                <div className="weekday-header">Tue</div>
                <div className="weekday-header">Wed</div>
                <div className="weekday-header">Thu</div>
                <div className="weekday-header">Fri</div>
                <div className="weekday-header">Sat</div>

                {days.map((day, index) => (
                    <div key={index} className={getDateCellClass(day)}>
                        <div className={getDayNumberClass(day)}>
                            {day.day}
                        </div>
                        {day.pnl && day.pnl.hasData && (
                            <div className={`pnl-value ${getDayStyle(day)}`}>
                                {formatPnL(day.pnl.value)}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PnLCalendar;